<template>
  <div class="home">
    <!-- 轮播图部分 -->
    <section class="hero">
      <div class="slider">
        <div 
          class="slide" 
          :class="{ active: currentIndex === 0 }"
        >
          <div class="slide-content">
            <h2>专业的机械设备解决方案提供商</h2>
            <p class="subtitle-en">Professional Mechanical Equipment Solutions Provider</p>
          </div>
        </div>
        <div 
          class="slide" 
          :class="{ active: currentIndex === 1 }"
        >
          <div class="slide-content">
            <h2>成熟的行业解决方案</h2>
            <p class="subtitle-en">Mature Industry Solutions</p>
          </div>
        </div>
        <div 
          class="slide" 
          :class="{ active: currentIndex === 2 }"
        >
          <div class="slide-content">
            <h2>改善您的生产力</h2>
            <p class="subtitle-en">Improve Your Productivity</p>
          </div>
        </div>
        
        <!-- 轮播图导航按钮 -->
        <button class="slider-btn prev" @click="prevSlide">‹</button>
        <button class="slider-btn next" @click="nextSlide">›</button>
      </div>
      <div class="slider-nav">
        <span 
          class="dot" 
          :class="{ active: currentIndex === 0 }"
          @click="setCurrentSlide(0)"
        ></span>
        <span 
          class="dot" 
          :class="{ active: currentIndex === 1 }"
          @click="setCurrentSlide(1)"
        ></span>
        <span 
          class="dot" 
          :class="{ active: currentIndex === 2 }"
          @click="setCurrentSlide(2)"
        ></span>
      </div>
    </section>

    <!-- 服务介绍部分 -->
    <section class="services">
      <div class="container">
        <div class="section-title">
          <h2>我们的服务</h2>
          <p>专业为您提供全方位的机械解决方案</p>
        </div>
        <div class="service-grid">
          <div class="service-card">
            <div class="service-icon">
              <!-- 使用简单的图标替代 -->
              <div class="icon-placeholder">🔧</div>
            </div>
            <h3>行业解决方案</h3>
            <p class="service-text-cn">针对不同行业提供定制化的机械设备解决方案，满足您的特定需求。</p>
            <p class="service-text-en">Mature Industry Solutions</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <div class="icon-placeholder">📈</div>
            </div>
            <h3>提高生产力</h3>
            <p class="service-text-cn">我们的设备能够显著提升生产效率，降低运营成本。</p>
            <p class="service-text-en">Improve Your Productivity</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <div class="icon-placeholder">🏆</div>
            </div>
            <h3>增强竞争力</h3>
            <p class="service-text-cn">通过先进的技术和可靠的质量，帮助您在市场中脱颖而出。</p>
            <p class="service-text-en">Enhance Your Competitiveness</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      currentIndex: 0,
      intervalId: null
    }
  },
  mounted() {
    // 自动轮播
    this.startAutoPlay();
  },
  beforeUnmount() {
    // 清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    setCurrentSlide(index) {
      this.currentIndex = index;
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % 3;
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + 3) % 3;
    },
    startAutoPlay() {
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, 5000); // 每5秒切换一次
    }
  }
}
</script>

<style scoped>
.home {
  margin-top: 80px;
}

/* 轮播图样式 */
.hero {
  position: relative;
  height: 500px;
  overflow: hidden;
}

.slider {
  position: relative;
  width: 100%;
  height: 100%;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  background-size: cover;
  background-position: center;
}

.slide.active {
  opacity: 1;
}

.slide:nth-child(1) {
  background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0.5)), 
              url('@/assets/images/image1.jpg') center/cover;
}

.slide:nth-child(2) {
  background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0.5)), 
              url('@/assets/images/image2.jpg') center/cover;
}

.slide:nth-child(3) {
  background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0.5)), 
              url('@/assets/images/image3.jpg') center/cover;
}

.slide-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  width: 100%;
  padding: 0 20px;
}

.slide-content h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.subtitle-cn {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}

.subtitle-en {
  font-size: 1rem;
  margin-bottom: 2rem;
  opacity: 0.8;
}

/* 轮播图导航按钮 */
.slider-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
  transition: background 0.3s;
}

.slider-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}

.slider-btn.prev {
  left: 20px;
}

.slider-btn.next {
  right: 20px;
}

.slider-nav {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
}

.dot {
  height: 12px;
  width: 12px;
  margin: 0 5px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.3s;
  cursor: pointer;
}

.dot.active {
  background-color: #fff;
}

/* 服务介绍样式 */
.services {
  padding: 80px 0;
  background-color: #f8f9fa;
}

.section-title {
  text-align: center;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 15px;
}

.section-title p {
  font-size: 1.1rem;
  color: #666;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.service-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  text-align: center;
  transition: transform 0.3s;
}

.service-card:hover {
  transform: translateY(-10px);
}

.service-icon {
  font-size: 3rem;
  margin-bottom: 20px;
  color: #409eff;
}

.icon-placeholder {
  font-size: 3rem;
}

.service-card h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #333;
}

.service-text-cn {
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}

.service-text-en {
  color: #999;
  font-size: 0.9rem;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .home {
    margin-top: 140px;
  }
  
  .hero {
    height: 400px;
  }
  
  .slide-content h2 {
    font-size: 2rem;
  }
  
  .subtitle-cn {
    font-size: 1rem;
  }
  
  .subtitle-en {
    font-size: 0.9rem;
  }
  
  .services {
    padding: 50px 0;
  }
  
  .service-grid {
    grid-template-columns: 1fr;
  }
  
  .contact {
    padding: 50px 0;
  }
  
  .slider-btn {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
  
  .slider-btn.prev {
    left: 10px;
  }
  
  .slider-btn.next {
    right: 10px;
  }
}
</style>